import { Box, IconButton, Paper, TextField, Typography } from '@mui/material'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useTranslation } from 'react-i18next'
import { buildTimeStringFromTimestamp } from '../../../../../components/common/time/timeHelper'
import GridItem from '../../../../kyc/kycPerson/components/GridItem'
import { SessionStatusBadge } from '../../../components/SessionStatusBadge'
import styles from './styles.module.scss'

export const SessionInfo = ({ session }) => {
  const { t } = useTranslation(['common', 'messages'])

  if (!session) return null

  const handleCopyUrl = () => {
    if (session.sessionUrl) {
      navigator.clipboard.writeText(session.sessionUrl)
    }
  }

  const handleOpenUrl = () => {
    if (session.sessionUrl) {
      window.open(session.sessionUrl, '_blank')
    }
  }

  return (
    <Paper elevation={0} className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h4">{t('common:sessionDetails')}</Typography>
        <SessionStatusBadge status={session.status} />
      </Box>

      <Box className={styles.gridItems}>
      <GridItem name={t('common:sessionId')} value={session._id || '---'} copyable={!!session._id} />
        <GridItem
          name={t('common:createdAt')}
          value={session.createdAt ? buildTimeStringFromTimestamp(session.createdAt) : '---'}
        />
        <GridItem
          name={t('common:completedAt')}
          value={session.completedAt ? buildTimeStringFromTimestamp(session.completedAt) : '---'}
        />
      </Box>

      {session.sessionUrl && (
        <Box className={styles.urlSection}>
          <Typography variant="subtitle2" color="textSecondary">
            {t('common:sessionUrl')}
          </Typography>
          <Box className={styles.urlContainer}>
            <Typography variant="body2" className={styles.urlText}>
              {session.sessionUrl}
            </Typography>
            <Box className={styles.urlActions}>
              <IconButton size="small" onClick={handleCopyUrl} title={t('common:copy')}>
                <ContentCopyOutlinedIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" onClick={handleOpenUrl} title={t('common:openInNewTab')}>
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      )}
    </Paper>
  )
}
